"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactRequiredIf = _interopRequireDefault(require("react-required-if"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Chevron = _interopRequireDefault(require("../../Icons/Chevron"));

var _createUniqueElementIds = require("../../utils/createUniqueElementIds/createUniqueElementIds");

var _DescriptionMessages = _interopRequireDefault(require("../FormControlFragments/DescriptionMessages"));

var _InputLabel = _interopRequireDefault(require("../FormControlFragments/InputLabel"));

var _excluded = ["ariaLabelledBy", "classes", "dataTestId", "description", "descriptionId", "errorMessages", "formControlId", "handleOnBlurValidation", "handleOnChange", "handleOnKeyPress", "inputId", "isDescriptionHtml", "isDisabled", "isOptional", "isRequired", "isValid", "label", "labelId", "name", "options", "size", "value"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Select = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, ref) {
  var ariaLabelledBy = _ref.ariaLabelledBy,
      classes = _ref.classes,
      dataTestId = _ref.dataTestId,
      description = _ref.description,
      descriptionId = _ref.descriptionId,
      errorMessages = _ref.errorMessages,
      formControlId = _ref.formControlId,
      handleOnBlurValidation = _ref.handleOnBlurValidation,
      handleOnChange = _ref.handleOnChange,
      handleOnKeyPress = _ref.handleOnKeyPress,
      inputId = _ref.inputId,
      isDescriptionHtml = _ref.isDescriptionHtml,
      isDisabled = _ref.isDisabled,
      isOptional = _ref.isOptional,
      isRequired = _ref.isRequired,
      isValid = _ref.isValid,
      label = _ref.label,
      labelId = _ref.labelId,
      name = _ref.name,
      options = _ref.options,
      size = _ref.size,
      value = _ref.value,
      additionalProps = _objectWithoutProperties(_ref, _excluded);

  var _useState = (0, _react.useState)(value),
      _useState2 = _slicedToArray(_useState, 2),
      updatedValue = _useState2[0],
      setUpdatedValue = _useState2[1];

  var _useState3 = (0, _react.useState)((0, _createUniqueElementIds.createUniqueElementIds)('label')),
      _useState4 = _slicedToArray(_useState3, 1),
      labelUniqueId = _useState4[0];

  var _useState5 = (0, _react.useState)((0, _createUniqueElementIds.createUniqueElementIds)('input')),
      _useState6 = _slicedToArray(_useState5, 1),
      inputUniqueId = _useState6[0];

  var _useState7 = (0, _react.useState)((0, _createUniqueElementIds.createUniqueElementIds)('description')),
      _useState8 = _slicedToArray(_useState7, 1),
      descriptionUniqueId = _useState8[0];

  var selectContainerStyles = (0, _classnames.default)('form-control__container form-control__container--select', {
    'form-control__container--error': !isValid
  }, classes);
  var selectStyles = (0, _classnames.default)('form-control__select', {
    'form-control__select--error': !isValid,
    'form-control__select--small': size === 'small'
  });
  (0, _react.useEffect)(function () {
    setUpdatedValue(value);
  }, [value]);

  var selectElement = /*#__PURE__*/_react.default.createElement("div", {
    className: "form-control__select-wrapper"
  }, /*#__PURE__*/_react.default.createElement("select", _extends({
    id: inputId || inputUniqueId,
    name: name,
    value: updatedValue || value,
    onBlur: function onBlur() {
      if (handleOnBlurValidation) {
        handleOnBlurValidation(value);
      }
    },
    onChange: handleOnChange,
    onKeyPress: handleOnKeyPress,
    disabled: isDisabled,
    "aria-labelledby": ariaLabelledBy ? "".concat(ariaLabelledBy, " ").concat(labelId || labelUniqueId) : null,
    "aria-describedby": description && (descriptionId || descriptionUniqueId) || errorMessages && !isValid && (descriptionId || descriptionUniqueId) || null,
    "aria-invalid": !isValid || null,
    className: selectStyles,
    ref: ref,
    required: isRequired,
    "data-testid": dataTestId
  }, additionalProps), options.map(function (option) {
    return option.options ? /*#__PURE__*/_react.default.createElement("optgroup", {
      label: option.label,
      key: option.label
    }, option.options.map(function (subOption) {
      return /*#__PURE__*/_react.default.createElement("option", {
        key: subOption.value,
        value: subOption.value,
        disabled: subOption.isDisabled,
        "data-testid": subOption.dataTestId
      }, subOption.label);
    })) : /*#__PURE__*/_react.default.createElement("option", {
      key: option.value,
      value: option.value,
      disabled: option.isDisabled,
      "data-testid": option.dataTestId
    }, option.label);
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "form-control__select-arrow-wrapper",
    "aria-hidden": "true"
  }, /*#__PURE__*/_react.default.createElement(_Chevron.default, null)));

  return /*#__PURE__*/_react.default.createElement("div", {
    className: selectContainerStyles,
    id: formControlId
  }, /*#__PURE__*/_react.default.createElement(_InputLabel.default, {
    inputId: inputId,
    inputUniqueId: inputUniqueId,
    isDisabled: isDisabled,
    isOptional: isOptional,
    isValid: isValid,
    label: label,
    labelId: labelId,
    labelUniqueId: labelUniqueId
  }), selectElement, (description || errorMessages.length > 0 && !isValid) && /*#__PURE__*/_react.default.createElement(_DescriptionMessages.default, {
    description: description,
    descriptionId: descriptionId,
    descriptionUniqueId: descriptionUniqueId,
    errorMessages: errorMessages,
    isDescriptionHtml: isDescriptionHtml,
    isDisabled: isDisabled,
    isValid: isValid
  }));
}); // needed for prop type checking refs in server side rendered apps

var Element = typeof Element === 'undefined' ? function () {} : Element; // eslint-disable-line

Select.displayName = 'Select';
Select.propTypes = {
  /**
   Optional. Adds `aria-labelledby` attribute to associate the input with a page level error message.
   */
  ariaLabelledBy: _propTypes.default.string,

  /**
   Optional. String to add custom class(es) to the select container.
   */
  classes: _propTypes.default.string,

  /**
   Optional. A unique identifier passed to the element for use in testing scenarios. Defaults to `null`.
   */
  dataTestId: _propTypes.default.string,

  /**
   Optional. Custom description that appears below the select input. Can be a string or a React component (object).
   */
  description: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.shape({})]),

  /**
   Optional. A unique identifier passed to the description's `id` attribute. Defaults to `null`.
   */
  descriptionId: _propTypes.default.string,

  /**
   Optional. Array of error message strings displayed when `isValid` is `false`.
   */
  errorMessages: _propTypes.default.arrayOf(_propTypes.default.string),

  /**
   Optional. A unique identifier passed to the component wrapper's `id` attribute. Defaults to `null`.
   */
  formControlId: _propTypes.default.string,

  /**
   Optional. A function passed in to validate the select value on blur. The value for the select must be passed in (`(v) => formatCallback(v)`) and will update when the select is blurred.
   */
  handleOnBlurValidation: _propTypes.default.func,

  /**
   Required. The function passed to the input's `onChange` method.
   */
  handleOnChange: _propTypes.default.func.isRequired,

  /**
    Optional. The function passed to the input's `onKeyPress` method.
    */
  handleOnKeyPress: _propTypes.default.func,

  /**
   Optional. A unique identifier passed to the input's `id` attribute. Defaults to `null`.
   */
  inputId: _propTypes.default.string,

  /**
   Optional. Used to pass HTML to the `description` prop. Defaults to `false`.
   */
  isDescriptionHtml: _propTypes.default.bool,

  /**
   Optional. Passes the `disabled` prop to the checkbox input. Defaults to `false`.
   */
  isDisabled: _propTypes.default.bool,

  /**
   Optional. Should not be used if `isRequired` is used. Adds "Optional" text to the right of the legend. Defaults to `false`.
   */
  isOptional: _propTypes.default.bool,

  /**
   Optional. Adds the `required` attribute to the input. Defaults `false`.
   */
  isRequired: _propTypes.default.bool,

  /**
   Optional. Sets the error state for the component and it's checkboxes when set to `false`. Defaults to `true`.
   */
  isValid: _propTypes.default.bool,

  /**
   Required. The label that appears above the select input.
   */
  label: _propTypes.default.string.isRequired,

  /**
    Optional. A unique identifier passed to the input label's `id` attribute. Defaults to `null`.
    */
  labelId: _propTypes.default.string,

  /**
   Required. The name attribute for the input, which gets associated to the value.
   */
  name: _propTypes.default.string.isRequired,

  /**
   Required. The options shown when the select element is interacted with.
   */
  options: _propTypes.default.arrayOf(_propTypes.default.shape({
    label: _propTypes.default.string.isRequired,
    value: (0, _reactRequiredIf.default)(_propTypes.default.string, function (props) {
      return !props.options;
    }),
    options: _propTypes.default.arrayOf(_propTypes.default.shape({
      label: _propTypes.default.string.isRequired,
      value: _propTypes.default.string.isRequired
    }))
  })).isRequired,

  /**
    Optional. Controls the size of the box and label. Options: 'large', 'small'. Defaults to 'large'.
    */
  size: _propTypes.default.oneOf(['large', 'small']),

  /**
   Optional. The unique value for the select input.
   */
  value: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string])
};
Select.defaultProps = {
  ariaLabelledBy: null,
  classes: '',
  dataTestId: '',
  description: '',
  descriptionId: '',
  errorMessages: [],
  formControlId: '',
  handleOnBlurValidation: function handleOnBlurValidation() {},
  handleOnKeyPress: function handleOnKeyPress() {},
  inputId: '',
  isDescriptionHtml: false,
  isDisabled: false,
  isOptional: false,
  isRequired: false,
  isValid: true,
  labelId: '',
  size: 'large',
  value: ''
};
var _default = Select;
exports.default = _default;